document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ms').forEach(function (section) {
    var railEl = section.querySelector('.ms__rail');
    if (!railEl || !window.Splide) return;

    var cs    = getComputedStyle(section);
    var tileW = parseInt(cs.getPropertyValue('--tile-w'))   || 260;
    var gapW  = parseInt(cs.getPropertyValue('--tile-gap')) || 16;
    var peekW = parseInt(cs.getPropertyValue('--peek'))     || 80;

    var isMobile = window.matchMedia('(max-width: 800px)');
    var mobile = isMobile.matches;
    isMobile.addEventListener('change', function(e){ mobile = e.matches; enforceLeftmostPlayback(); });

    // ===== Splide (loop ON) =====
    var rail = new Splide(railEl, {
      type: 'loop',                 // keep loop behavior
      fixedWidth: tileW,
      gap: gapW,
      focus: 0,
      trimSpace: false,
      arrows: false,
      pagination: false,
      drag: false,                  // custom swipe below
      padding: { left: 0, right: peekW + 'px' },
      flickPower: 400,
      dragMinThreshold: 10,
      updateOnMove: false,
      speed: 280,
      breakpoints: {
  1400: { fixedWidth: Math.max(240, tileW - 20), padding: { left: 0, right: Math.max(64, peekW - 16) + 'px' } },
  1100: { fixedWidth: Math.max(220, tileW - 40), padding: { left: 0, right: Math.max(56, peekW - 24) + 'px' } },
   990: { fixedWidth: 280, padding: { left: 0, right: '40px' } },
   640: { fixedWidth: 300, padding: { left: 0, right: '32px' } }
}
    });

    // ---------- Helpers ----------
    function isCloneSlide(slideEl){ return slideEl && slideEl.classList.contains('splide__slide--clone'); }
    function allVideos(){ return Array.prototype.slice.call(section.querySelectorAll('video')); }
    function pauseAllVideos(){ allVideos().forEach(function(v){ try{ v.pause(); }catch(e){} }); }
    function getSlideObjAt(idx){ return rail.Components.Slides.getAt(idx) || null; }
    function getActiveSlideObj(){ return rail.Components.Slides.getAt(rail.index) || null; }
    function getNextSlideObj(){
      var nextIdx = (rail.index + 1) % rail.length;
      return getSlideObjAt(nextIdx);
    }

    // Inert all clone slides: remove sources, force poster-only
    function inertCloneVideos(){
      section.querySelectorAll('.splide__slide--clone .ms__tile').forEach(function(tile){
        tile.classList.add('ms--clone');
        var v = tile.querySelector('video');
        if (!v) return;
        try { v.pause(); } catch(e){}
        v.removeAttribute('src');
        v.querySelectorAll('source').forEach(function(s){ s.remove(); });
        v.preload = 'none';
        try { v.load(); } catch(e){}
        // Keep the native poster visible
        v.style.visibility = 'hidden'; // rely on overlay poster image for visuals
      });
    }

    // Gate "ready" to the moment a real frame is painted
    function whenFirstFrame(v, cb){
      if (!v) return;
      if ('requestVideoFrameCallback' in v) {
        v.requestVideoFrameCallback(function(){ cb(); });
      } else {
        // Fallback: ensure decode started and a tick happened
        var done=false;
        var once=function(fn){ return function h(){ if(done) return; done=true; v.removeEventListener('timeupdate',h); v.removeEventListener('loadeddata',h); fn(); };};
        v.addEventListener('timeupdate', once(cb));
        v.addEventListener('loadeddata', once(function(){
          // nudge currentTime very slightly to force frame paint on iOS
          try { v.currentTime = Math.max(0, v.currentTime); } catch(e){}
          requestAnimationFrame(function(){ requestAnimationFrame(cb); });
        }));
      }
    }

    function markReadyFor(v){
      if (!v) return;
      var tile = v.closest('.ms__tile');
      if (tile) tile.classList.add('ms--ready');
      v.style.visibility = ''; // reveal video beneath poster when ready
    }

    function deprimeVideo(slideEl){
      var v = slideEl && slideEl.querySelector('video');
      if (!v) return;
      if (isCloneSlide(slideEl)) return;   // clones already inert
      // Mobile: keep hard-off unless active/next
      if (mobile) {
        if (v.preload !== 'none') v.preload = 'none';
      } else {
        if (v.preload !== 'metadata') v.preload = 'metadata';
      }
      // Hide video layer until we know a frame is available
      v.style.visibility = 'hidden';
    }

    function primeVideo(slideEl){
      var v = slideEl && slideEl.querySelector('video');
      if (!v) return;
      if (isCloneSlide(slideEl)) return;
      if (v.preload !== 'auto') { v.preload = 'auto'; try{ v.load(); }catch(e){} }
      whenFirstFrame(v, function(){ markReadyFor(v); });
    }

    function playVideoIn(slideEl){
      var v = slideEl && slideEl.querySelector('video');
      if (!v) return;
      if (isCloneSlide(slideEl)) return;
      v.muted = true; v.setAttribute('playsinline','');
      function tryPlay(){ try{ var p=v.play(); if(p && p.catch) p.catch(function(){});}catch(e){} }
      if (v.readyState >= 2) tryPlay();
      else { setTimeout(tryPlay, 60); setTimeout(tryPlay, 180); }
    }

    function enforceLeftmostPlayback(){
      // Double rAF to let Splide settle transforms
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          pauseAllVideos();

          rail.Components.Slides.forEach(function(S){
            if (S && S.slide) deprimeVideo(S.slide);
          });

          var activeObj = getActiveSlideObj();
          var nextObj   = getNextSlideObj();
          var activeEl  = activeObj && activeObj.slide ? activeObj.slide : null;
          var nextEl    = nextObj   && nextObj.slide   ? nextObj.slide   : null;

          if (activeEl) { primeVideo(activeEl); playVideoIn(activeEl); }
          if (nextEl)   { primeVideo(nextEl); }
        });
      });
    }

    // ---------- Right-swipe-only gesture ----------
    var track = railEl.querySelector('.splide__track');
    var startX=0, startY=0, tracking=false, moved=false;

    function onStart(e){
      var t = e.touches ? e.touches[0] : e;
      startX = t.clientX; startY = t.clientY;
      tracking = true; moved = false;
    }
    function onMove(e){
      if (!tracking) return;
      var t = e.touches ? e.touches[0] : e;
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy)) return; // mostly horizontal
      if (dx < 0) { e.preventDefault(); e.stopPropagation(); moved = true; return; } // block left swipe
      if (dx > 24) { e.preventDefault(); e.stopPropagation(); moved = true; rail.go('>'); tracking = false; }
    }
    function onEnd(){ tracking = false; if (moved) enforceLeftmostPlayback(); }

    track.addEventListener('touchstart', onStart, { passive: true });
    track.addEventListener('touchmove',  onMove,  { passive: false });
    track.addEventListener('touchend',   onEnd,   { passive: true });

    track.addEventListener('mousedown', function(e){
      onStart(e);
      document.addEventListener('mousemove', onMove, { passive:false });
      document.addEventListener('mouseup', function up(ev){
        document.removeEventListener('mousemove', onMove);
        onEnd(ev);
      }, { once:true });
    });

    rail.on('click', function () { rail.go('>'); });

    // Prime next slide as soon as Splide starts moving to it
    rail.on('move', function(newIndex){
      var S = rail.Components.Slides.getAt(newIndex);
      if (S && S.slide) primeVideo(S.slide);
      var nextIdx = (newIndex + 1) % rail.length;
      var N = rail.Components.Slides.getAt(nextIdx);
      if (N && N.slide) primeVideo(N.slide);
    });

    // Lifecycle
    rail.on('mounted', function(){
      inertCloneVideos();
      enforceLeftmostPlayback();
    });
    rail.on('updated', inertCloneVideos);
    rail.on('resized', enforceLeftmostPlayback);
    rail.on('moved',   enforceLeftmostPlayback);
    rail.on('refresh', function(){ inertCloneVideos(); enforceLeftmostPlayback(); });

    // Page visibility
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) pauseAllVideos();
      else enforceLeftmostPlayback();
    });

    // Only run when in view (helps mobile)
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) enforceLeftmostPlayback();
        else pauseAllVideos();
      });
    }, { threshold: 0.3 });
    io.observe(section);

    // Mark quick-ready tiles on boot
    Array.prototype.slice.call(section.querySelectorAll('video')).forEach(function(v){
      whenFirstFrame(v, function(){ markReadyFor(v); });
      // ensure video hidden until it's painted
      v.style.visibility = 'hidden';
    });

    rail.mount();
    setTimeout(function(){ inertCloneVideos(); enforceLeftmostPlayback(); }, 80);
  });
});

